/**! Qoopido.demand 5.0.1-alpha.2 | https://github.com/dlueth/qoopido.demand | (c) 2018 Dirk Lueth */
(function () {
	"use strict";

	function definition(abstractHandler) {
		function HandlerText() {}
		var regexMatchType = /^text\/.+/;
		HandlerText.prototype = {
			validate: function (type) {
				return regexMatchType.test(type)
			},
			process: function (dependency) {
				provide(function () {
					return dependency.source
				})
			}
		};
		return new(HandlerText.extends(abstractHandler))
	}
	provide(["/demand/abstract/handler"], definition)
})();
